'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initProductContainer = exports.getVariant = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Helpers = require('common/Helpers');

var _handlers = require('./handlers');

var _handlers2 = require('components/Product/handlers');

var _ExploreBySeries = require('../components/ExploreBySeries');

var _ExploreBySeries2 = _interopRequireDefault(_ExploreBySeries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable camelcase */
// original state/product.js at bottom of file

var getVariantHandleFromOptions = function getVariantHandleFromOptions(optionsState, productOptions) {
  return productOptions.sort(function (a, b) {
    return a.position - b.position;
  }).map(function (option) {
    return optionsState[option.handle];
  }).join('-');
};

var getVariantIdFromState = function getVariantIdFromState(container) {
  return (0, _handlers.getState)(container).variantId;
};

var getVariantIdFromVariantHandle = function getVariantIdFromVariantHandle(container) {
  var variants = (0, _handlers.getState)('variant');

  var _getState = (0, _handlers.getState)(container),
      variantHandle = _getState.variantHandle;

  return variants[variantHandle];
};

var getVariantIdFromOptions = function getVariantIdFromOptions(container) {
  var _getState2 = (0, _handlers.getState)(container),
      options = _getState2.options,
      _data = _getState2._data;

  var variants = (0, _handlers.getState)('variant');
  var optionsHandleSuffix = getVariantHandleFromOptions(options, _data.product.options);
  var variantHandle = _data.product.handle + '-' + optionsHandleSuffix;

  var _ref = _data.variant.find(function (variant) {
    return variant.options.every(function (variantOption) {
      return Object.values(options).includes((0, _Helpers.handlize)(variantOption));
    });
  }) || {},
      variantIdFromVariantData = _ref.id;

  if (_data.product.childrenWithVariants) return null;

  return variants[variantHandle] || variantIdFromVariantData;
};

var getVariantIdFromDom = function getVariantIdFromDom(container) {
  var variants = (0, _handlers.getState)('variant');

  var handle = (0, _handlers.getState)(container)._data.product.handle;

  var domHandleSuffix = $('[data-option-value].is-active', container).get().map(function (option) {
    return (0, _Helpers.handlize)(option.dataset.optionValue);
  }).join('-');
  var variantHandle = handle + '-' + domHandleSuffix;

  return variants[variantHandle];
};

var getVariant = exports.getVariant = function getVariant(container) {
  if (getVariantIdFromState(container)) {
    // console.log('getVariantIdFromState(container)', getVariantIdFromState(container));
    return getVariantIdFromState(container);
  }

  if (getVariantIdFromVariantHandle(container)) {
    return getVariantIdFromVariantHandle(container);
  }

  if (getVariantIdFromOptions(container)) {
    return getVariantIdFromOptions(container);
  }

  if (getVariantIdFromDom(container)) {
    return getVariantIdFromDom(container);
  }

  return container.variantId;
};

var updateVariant = function updateVariant(data) {
  var id = data.id;

  var productContainer = (0, _Helpers.getContainer)({ id: id });
  var variantId = getVariantIdFromOptions(productContainer);
  var change = 'variant';
  var container = 'product';

  (0, _handlers.setState)({ id: id, change: change, container: container, variantId: variantId });
};

var updateVariantId = function updateVariantId(data) {
  var change = 'variant-id';
  var container = 'product';
  var id = data.id,
      variantId = data.variantId;


  (0, _handlers.setState)({ id: id, change: change, container: container, variantId: variantId });
};

var updateInventory = function updateInventory(data) {
  var _getVariant = getVariant(data.id),
      inventory = _getVariant.inventory;

  var change = 'inventory';
  var container = 'product';

  (0, _handlers.setState)(Object.assign({}, data, { inventory: inventory, change: change, container: container }));
};

var updateQuantity = function updateQuantity(data) {
  var container = 'product';
  var change = 'quantity';

  (0, _handlers.setState)(Object.assign({}, data, { change: change, container: container }));
};

var updateOptionValue = function updateOptionValue(data) {
  var id = data.id,
      name = data.name,
      value = data.value;

  var container = 'product';
  var change = 'option_value';
  var state = (0, _handlers.getState)(id);
  var options = Object.assign({}, state.options, (0, _defineProperty3.default)({}, name, value));

  (0, _handlers.setState)({ id: id, container: container, change: change, options: options });
};

var getInitialOptionValues = function getInitialOptionValues(options, product) {
  if (product.main) {
    var currentProductHandle = (0, _handlers2.getCurrentProductHandle)();

    return options.map(function (option) {
      return (0, _Helpers.handlize)(option.value);
    }).filter(function (option) {
      return currentProductHandle.includes(option);
    }).filter(function (possibleOption, i, options) {
      return options.every(function (option) {
        return option === possibleOption || !option.includes(possibleOption);
      });
    }).reduce(function (options, option) {
      var _product$options$find = product.options.find(function (productOption) {
        var handlizedValues = productOption.values.map(function (value) {
          return (0, _Helpers.handlize)(value);
        });
        return handlizedValues.includes(option);
      }),
          handle = _product$options$find.handle;

      return Object.assign({}, options, (0, _defineProperty3.default)({}, handle, option));
    }, {});
  }

  return product.initialOptions;
};

var getInitialVariantData = function getInitialVariantData(product, initialOptions) {
  var _id = product._id,
      handle = product.handle,
      _product$child_handle = product.child_handles,
      child_handles = _product$child_handle === undefined ? [] : _product$child_handle,
      childrenWithVariants = product.childrenWithVariants,
      _product$options = product.options,
      options = _product$options === undefined ? [] : _product$options,
      initialVariantId = product.initialVariantId,
      _product$initialVaria = product.initialVariantHandle,
      initialVariantHandle = _product$initialVaria === undefined ? '' : _product$initialVaria,
      _product$variantIds = product.variantIds,
      variantIds = _product$variantIds === undefined ? [] : _product$variantIds;

  var isParent = child_handles.length > 0;
  var containsInitialVariantId = variantIds.includes(initialVariantId);
  var isDYProduct = !_id;
  var isWatchOrStrapOrChild = !isParent && containsInitialVariantId;

  if (isDYProduct || isWatchOrStrapOrChild) {
    return { variantId: Number(initialVariantId), variantHandle: handle + '-' + initialVariantHandle };
  }

  if (isParent && !containsInitialVariantId) {
    return { variantId: Number(initialVariantId), variantHandle: handle + '-' + initialVariantHandle };
  }

  if (isParent && containsInitialVariantId && !childrenWithVariants) {
    // could also use `variantHandle: getCurrentProductHandle()` on product pages
    return { variantId: undefined, variantHandle: handle + '-' + getVariantHandleFromOptions(initialOptions, options) };
  }

  return { variantId: undefined, variantHandle: undefined };
};

var initProductContainer = exports.initProductContainer = function initProductContainer(productContainer) {
  return new Promise(function (resolve) {
    var _parseContainerData = (0, _handlers.parseContainerData)(productContainer),
        _parseContainerData$i = _parseContainerData.image,
        image = _parseContainerData$i === undefined ? [] : _parseContainerData$i,
        _parseContainerData$o = _parseContainerData.option,
        option = _parseContainerData$o === undefined ? [] : _parseContainerData$o,
        product = _parseContainerData.product,
        _parseContainerData$v = _parseContainerData.variant,
        variants = _parseContainerData$v === undefined ? [] : _parseContainerData$v;

    if (!product) resolve();

    var id = productContainer.dataset.containerId;

    var container = 'product';
    var change = 'init';
    var options = getInitialOptionValues(option, product, productContainer);
    var variantInformation = getInitialVariantData(product, options);
    var quantity = parseInt($(_Dom2.default.quantityValue, productContainer).val()) || 1;
    var _data = { image: image, option: option, variant: variants, product: product };
    var data = Object.assign({ id: id, container: container, change: change, options: options }, variantInformation, { quantity: quantity, _data: _data });

    (0, _handlers.setState)(data);
    resolve(data);
  });
};

exports.default = {
  updateQuantity: updateQuantity,
  updateOptionValue: updateOptionValue,
  updateVariant: updateVariant,
  updateVariantId: updateVariantId,
  updateInventory: updateInventory,
  getVariant: getVariant
};

// original state/product.js
// import SizeGuideModal from '../components/SizeGuide';

document.addEventListener('DOMContentLoaded', function () {
  // SizeGuideModal.init();
  _ExploreBySeries2.default.init();
});

window.addEventListener('load', function () {});